import React from 'react';
import { PALMISTRY_PRIMARY_CTA_LABEL } from '../../data/palmistry101Content';

/**
 * One primary purchase action across hero, sticky bar, and purchase section.
 * Uses checkout URL when set; otherwise calls onFallback (scroll to purchase + explanation).
 */
export default function PalmistryPrimaryCta({ checkoutUrl, onFallback, className = '' }) {
  const label = PALMISTRY_PRIMARY_CTA_LABEL;
  const trimmed = (checkoutUrl || '').trim();
  const isExternal = /^https?:\/\//i.test(trimmed);
  const combined = ['amm-palmistry101-btn', 'amm-palmistry101-btn-primary', className].filter(Boolean).join(' ');

  if (trimmed) {
    return (
      <a
        href={trimmed}
        className={combined}
        {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {label}
      </a>
    );
  }

  return (
    <button type="button" className={combined} onClick={onFallback}>
      {label}
    </button>
  );
}
